import { useEffect, useState } from "react";
import { Textarea } from "./../../Components/ui/textarea";
import { Input } from "./../../Components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./../../Components/ui/select";
import { useOverview } from "./../../hooks";
import { removeUnderscores } from "./../../Utils/helperFunction";
import { stateList } from "./../../api";

function AddBeneficiary2({
  HandleSubmit,
  handleInputChange,
  formData,
  errors,
}) {
  const { beniCreationError } = useOverview();
  const [states, setStates] = useState([]);
  const [statesLoading, setStatesLoading] = useState(false);
  const [searchState, setSearchState] = useState("");

  useEffect(() => {
    if (!formData?.country_code) {
      setStates([]);
      return;
    }

    const fetchStates = async () => {
      setStatesLoading(true);
      try {
        const response = await stateList(formData.country_code);
        const data = response?.data?.data || response?.data || [];
        setStates(
          Array.isArray(data)
            ? data.map((state) => ({
                ...state,
                normalizedName: state.stateName
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .toLowerCase(),
              }))
            : []
        );
      } catch (error) {
        setStates([]);
      } finally {
        setStatesLoading(false);
      }
    };

    fetchStates();
  }, [formData?.country_code]);
  const filteredStates = states.filter((state) =>
    state.normalizedName.includes(
      searchState
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
    )
  );

  return (
    <>
      <form onSubmit={HandleSubmit}>
        <div className="h-[calc(100vh-145px)] space-y-4 py-6">
          <div className="space-y-2">
            <label className="block text-xs text-blackShade font-geomanistBold mb-2">
              Postal Code
            </label>
            <Input
              type="string"
              // placeholder="Postal Code"
              value={formData?.postcode}
              onChange={(e) => handleInputChange("postcode", e.target.value)}
              className={`text-sm border font-geomanistBold ${
                errors?.postcode ? "border-red-500" : ""
              }`}
            />
            {errors?.postcode && (
              <p className="text-xs text-red-500 mt-1">{errors?.postcode}</p>
            )}
          </div>
          <div className="space-y-2">
            <label className="block text-xs text-blackShade font-geomanistBold mb-2">
              State
            </label>
            {states.length > 0 ? (
              <Select
                value={formData.state}
                onValueChange={(value) => handleInputChange("state", value)}
                disabled={statesLoading}
                onOpenChange={(open) => {
                  if (!open) setSearchState("");
                }}
              >
                <SelectTrigger
                  className={`w-full font-geomanistBold p-3 ${
                    errors?.state ? "border-red-500" : ""
                  }`}
                >
                  <SelectValue
                    placeholder={statesLoading ? "Loading..." : "Select State"}
                  >
                    <span className="font-geomanistBold">
                      {states.find((s) => s.stateCode === formData.state)
                        ?.stateName || formData.state}
                    </span>
                  </SelectValue>
                </SelectTrigger>
                <SelectContent
                  className="z-[9999]"
                  searchable
                  searchValue={searchState}
                  onSearchChange={setSearchState}
                >
                  {filteredStates.length > 0 ? (
                    filteredStates.map((s, index) => (
                      <SelectItem
                        key={s.stateCode}
                        value={s.stateCode}
                        isLastItem={index === filteredStates.length - 1}
                      >
                        <span className="font-geomanistBold">
                          {s.stateName}
                        </span>
                      </SelectItem>
                    ))
                  ) : (
                    <div className="px-4 py-3 text-sm text-gray-500">
                      No states found
                    </div>
                  )}
                </SelectContent>
              </Select>
            ) : (
            <Input
              value={formData.state}
              onChange={(e) => handleInputChange("state", e.target.value)}
              placeholder={statesLoading ? "Loading states..." : ""}
              disabled={statesLoading}
              className={`text-sm border font-geomanistBold ${
                errors.state ? "border-red-500" : ""
              }`}
            />
            )}
            {errors.state && (
              <p className="text-xs text-red-500 mt-1">{errors.state}</p>
            )}
          </div>
          <div className="space-y-2">
            <label className="block text-xs text-blackShade font-geomanistBold mb-2">
              City
            </label>
            <Input
              value={formData.city}
              onChange={(e) => handleInputChange("city", e.target.value)}
              className={`text-sm border font-geomanistBold ${
                errors.city ? "border-red-500" : ""
              }`}
            />
            {errors.city && (
              <p className="text-xs text-red-500 mt-1">{errors.city}</p>
            )}
          </div>
          <div className="space-y-2">
            <label className="block text-xs text-blackShade font-geomanistBold mb-2">
              Address
            </label>
            <Textarea
              value={formData.street_address}
              onChange={(e) =>
                handleInputChange("street_address", e.target.value)
              }
              className={`text-sm border font-geomanistBold ${
                errors.street_address ? "border-red-500" : ""
              }`}
            />
            {errors.street_address && (
              <p className="text-xs text-red-500 mt-1">
                {removeUnderscores(errors.street_address)}
              </p>
            )}
          </div>

          <div className="space-y-2">
            <label className="block text-md text-red-500 font-geomanistBold mt-10">
              {removeUnderscores(beniCreationError)}
            </label>
          </div>
        </div>
      </form>
    </>
  );
}

export default AddBeneficiary2;
